// extracted by mini-css-extract-plugin
module.exports = {"container":"EmbeddedVideo_container__6_zCU","content":"EmbeddedVideo_content__TIyWX","headline":"EmbeddedVideo_headline__wR_PH","subHeadline":"EmbeddedVideo_subHeadline__YRMs7"};